'use client';

import { Suspense, useState, useEffect, useRef } from 'react';
import PricingCards from './components/PricingCards';
import PaymentSection from './components/PaymentSection';
import FAQSection from './components/FAQSection';
import ScrollToTop from './components/ScrollToTop';
import LimitedOfferHeader from './components/Header';
import SubscriptionInfo from './components/SubscriptionInfo.jsx';
import FeaturesSection from './components/FeaturesSection.jsx';
import HeroHeading from './components/HeroHeading';
import AsSeenOn from './components/AsSeenOn';
import StatsSection from './components/StatsSection';
import { useStripeContext } from '@/context/StripeContextProvider';
import { Testimonies } from '@/components/molecules/Testimonies';
import { TestimoniesData } from '@/features/PreCheckoutPage';
import Link from 'next/link';
import classNames from 'classnames';


const ClientPricingPage = ({ userEmail, onEmailChange }) => {
    const { stripeData } = useStripeContext();
    const scrollableElement = useRef(null);
    const [selectedPlan, setSelectedPlan] = useState("");
    const { prices, monthlyTrialEnd, annualTrialEnd, discounts, monthlyClientSecret, annualClientSecret } = stripeData;
    const monthlyPrice = prices?.find(price => price.interval === 'month');
    const annualPrice = prices?.find(price => price.interval === 'year');

    console.log('ClientPricingPage', { prices, monthlyPrice, annualPrice, monthlyClientSecret, annualClientSecret });

    useEffect(() => {
        if (prices && prices.length > 0) {
            setSelectedPlan(prices[0]?.interval);
        }
    }, [prices]);

    if (!prices || prices.length === 0 || !monthlyPrice || !annualPrice) {
        return null;
    }

    return (
        <Suspense fallback={() => null}>
            <div
                ref={scrollableElement}
                className="bg-gray-50 h-[calc(100vh-80px)] overflow-y-auto font-montserrat">
                <div className="max-w-md mx-auto bg-white">
                    <div className='pt-8 pb-6 px-6'>
                        <LimitedOfferHeader />
                    </div>
                    <main className="pb-32">
                        <PricingCards
                            prices={prices}
                            discounts={discounts}
                            onPlanChange={setSelectedPlan}
                            plan={selectedPlan} />
                        <div className={classNames({
                            "hidden": selectedPlan !== 'year'
                        })}>
                            {annualClientSecret &&
                                <PaymentSection
                                    plan="year"
                                    userEmail={userEmail}
                                    onEmailChange={onEmailChange}
                                    clientSecret={annualClientSecret} />}
                        </div>
                        <div className={classNames({
                            "hidden": selectedPlan !== 'month'
                        })}>
                            {monthlyClientSecret &&
                                <PaymentSection
                                    plan="month"
                                    userEmail={userEmail}
                                    onEmailChange={onEmailChange}
                                    clientSecret={monthlyClientSecret} />}
                        </div>
                        <div className="p-4 space-y-8">
                            <SubscriptionInfo
                                isAnnual={selectedPlan === "year"}
                                price={selectedPlan === "year" ? annualPrice?.amount : monthlyPrice?.amount}
                                trialEndDate={selectedPlan === 'month'
                                    ? monthlyTrialEnd : annualTrialEnd} />
                            <FeaturesSection />
                            <Testimonies testimonies={TestimoniesData} />
                            <HeroHeading />
                            <AsSeenOn />
                            <StatsSection />
                            <div className="text-center py-6 text-gray-500 text-sm">
                                Cancel anytime, no questions asked
                            </div>

                            <FAQSection />
                            <div className="mt-8 text-center text-xs text-gray-500 
                            flex justify-center space-x-2">
                                <Link
                                    target='_blank'
                                    href="https://www.atly.com/terms-of-use">
                                    Terms of Service
                                </Link>
                                <span>•</span>
                                <Link
                                    target='_blank'
                                    href="https://www.atly.com/terms-of-use">
                                    Privacy Policy
                                </Link>
                            </div>
                        </div>
                    </main>
                    <ScrollToTop
                        scrollableElement={scrollableElement.current}
                        elementId="payment-section" />
                </div>
            </div>
        </Suspense>
    );
};

export default ClientPricingPage; 